/**
 * Devuelve el nombre de un doctor con prefijo "Dr. " sólo si aún no lo tiene.
 * Reconoce "Dr", "Dr.", "Dra", "Dra." (case-insensitive) al inicio del string.
 */
export function doctorLabel(name) {
  if (!name) return "";
  const clean = name.trim();
  if (/^dr[.a]?\.?\s/i.test(clean)) return clean;
  return `Dr. ${clean}`;
}
